import React, { useEffect, useState } from "react";
import { Box, Text } from "@chakra-ui/layout";
import { Select } from "@chakra-ui/select";
import { Flex } from "@chakra-ui/react";

function LocationFilter(props) {
  //   const [selectedNodeType, setSelectedNodeType] = useState(null);

  //   const { nodeTypeList, setNodeTypeId } = props;

  //   const onHandleChange = (e) => {
  //     setSelectedNodeType(e.target.value);
  //   };

  //   useEffect(() => {
  //     setNodeTypeId(selectedNodeType);
  //   }, [selectedNodeType]);

  return (
    <Box>
      <Flex alignItems="center">
        <Select
          bg="#FFFFFF"
          fontSize="15px"
          width="198px"
          height="2.5rem"
          id="user_type"
          size="lg"
          mr="12px"
          color="#7B818A"
          fontWeight="bold"
          // value={selectedNodeType}
          // onChange={onHandleChange}
          placeholder="Location"
        >
          {/* {nodeTypeList?.data?.map((list) => (
              <option key={list.id} value={list.id}>
                {list.name}
              </option>
            ))} */}
          <option>jaipur</option>
        </Select>
      </Flex>
    </Box>
  );
}

export default LocationFilter;
